var _rect, _rect2, _rect3, _rect4, _rect5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Disconnected50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 24.042,
    x: 15.568,
    y: 17.229,
    fill: "#3dd9eb",
    transform: "rotate(-45.001 18.75 29.25)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13.075,
    height: 19.799,
    x: 7.085,
    y: 24.478,
    fill: "#3dd9eb",
    transform: "rotate(-45.001 13.622 34.378)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.951,
    height: 4,
    x: 4.335,
    y: 37.69,
    fill: "#3dd9eb",
    transform: "rotate(-45.001 8.31 39.69)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.468,
    height: 19.799,
    x: 16.139,
    y: 20.728,
    fill: "#00b3d7",
    transform: "rotate(-45.001 17.372 30.628)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 4,
    x: 8.561,
    y: 35.94,
    fill: "#00b3d7",
    transform: "rotate(-45.001 10.06 37.94)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 8.138,
    height: 4,
    x: 26.308,
    y: 22.623,
    fill: "#f5bc00",
    transform: "rotate(-45.001 30.377 24.623)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.138,
    height: 4,
    x: 19.308,
    y: 15.623,
    fill: "#f5bc00",
    transform: "rotate(-45.001 23.377 17.623)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 24.042,
    x: 26.068,
    y: 6.729,
    fill: "#6c19ff",
    transform: "rotate(-45.001 29.25 18.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.075,
    height: 19.799,
    x: 27.84,
    y: 3.723,
    fill: "#6c19ff",
    transform: "rotate(-45.001 34.377 13.623)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.951,
    height: 4,
    x: 35.715,
    y: 6.31,
    fill: "#6c19ff",
    transform: "rotate(-45.001 39.69 8.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.468,
    height: 19.799,
    x: 29.393,
    y: 7.473,
    fill: "#2100c4",
    transform: "rotate(-45.001 30.627 17.373)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 4,
    x: 36.44,
    y: 8.061,
    fill: "#2100c4",
    transform: "rotate(-45.001 37.94 10.061)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Disconnected50);
export default __webpack_public_path__ + "static/media/icons8-disconnected-50.30aa918fc13711f63a08b6ddd5ef32e0.svg";
export { ForwardRef as ReactComponent };